import { Component, Input, OnInit } from '@angular/core';
import { ModuleSpecial } from '@app/models/models';
import { TranslateService } from '@ngx-translate/core';
import {transition, trigger, useAnimation} from '@angular/animations';
import { slideUp } from '@app/shared/animations/slideUp';
import { slideDown } from '@app/shared/animations/slideDown';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-bloc-special',
  templateUrl: './bloc-special.component.html',
  styleUrls: ['./bloc-special.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('toggleSolution', [
      transition('void => *', [
        useAnimation(slideDown)
      ]),
      transition('* => void', [
        useAnimation(slideUp)
      ])
    ])
  ]
})
export class BlocSpecialComponent implements OnInit {

  @Input() module: ModuleSpecial;

  computedTitle: string;
  titleClasses = ['title', 'bloc-special__title'];
  showSolution = false;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    if (this.module.subtype !== 'regle') { this.titleClasses.push('title--h4'); }
    switch (this.module.subtype) {
      case 'ensavoirplus':
      case 'attention':
        this.computedTitle = this.translate.instant(`Common.Library.Modules.${this.module.subtype}`);
        break;
      default:
        this.computedTitle = this.module.title ? this.module.title : null ;
        break;
    }
  }

  toggleSolution() {
    this.showSolution = !this.showSolution;
  }

}
